const logger = console;
var oAuthConstants = require('../../Auth/oAuthConstants.js');
const iFrameManager = (function () {
    return {
        initSilentRenewListner: initSilentRenewListner,
        notifyParent: notifyParent,
        loadSilentRenewIFrame: loadSilentRenewIFrame,
        removeIFrameOnTimeout: removeIFrameOnTimeout,
        loadCheckCookieIFrame: loadCheckCookieIFrame,
        checkCookieStatus: checkCookieStatus,
        loadCheckSessionIFrame: loadCheckSessionIFrame,
        checkSessionIFrameStatus: checkSessionIFrameStatus
    };

    function initSilentRenewListner(storeUser, errorCb) {
        if (storeUser) {
            window.addEventListener('message', receiveMessage, false);
        }

        function receiveMessage(event) {
            var origin = event.origin || event.originalEvent.origin;
            if (origin !== (location.protocol + '//' + location.host))
                return;
            logger.log('initSilentRenewListner received response from authorize');

            try {
                var user = JSON.parse(event.data);
                if (user && user.access_token) {
                    storeUser(user);
                }
                else {
                    errorCb(user);
                }
            }
            catch (e) {
                logger.log('unable to parse user');
                errorCb(event.data)
            }

            // remove the iframe once the tokens are stored
            setTimeout(() => {
                window.removeEventListener('message', receiveMessage, false);
                cleanUpIFrame('silent-renew-iframe');
            }, 300);
        }
    }

    function notifyParent(user) {
        logger.log('notifying parent');
        window.parent.postMessage(JSON.stringify(user),
            (location.protocol + '//' + location.host));
        return Promise.resolve();
    }

    function loadSilentRenewIFrame(url) {
        var silentRenewIFrame = document.createElement('iframe');
        silentRenewIFrame.id = 'silent-renew-iframe';
        silentRenewIFrame.src = url;
        silentRenewIFrame.style.display = 'none';
        document.body.appendChild(silentRenewIFrame);

        return silentRenewIFrame;
    }

    var tokenReceiveTimeout;
    function removeIFrameOnTimeout(silentRequestTimeout, iFrameId) {

        tokenReceiveTimeout = setTimeout(() => {
            if (document.getElementById(iFrameId)) {
                //window.removeEventListener('message', receiveMessage, false);

                //No response from authorize so redirect user back 
                var err = {
                    error: 'no_response_from_auth',
                    error_description: 'Either no response from auth or the response with not supported frame ancestor csp.'
                }

                notifyParent(err);
            }

            cleanUpIFrame(iFrameId);
        }, silentRequestTimeout);
    }

    function cleanUpIFrame(iFrameId) {
        removeIFrame(iFrameId);
        clearTimeout(tokenReceiveTimeout);
    }

    function removeIFrame(iFrameId) {
        var element = document.getElementById(iFrameId);
        if (element) {
            element.parentNode.removeChild(element);
        }
    }

    function loadCheckCookieIFrame(url, onIframeLoad, followCookieCb) {
        var checkSessionCookieIFrame = document.createElement('iframe');
        var checkSessionCookieUrl = url + '/authorize/api/oauth2/check_cookie_iframe?show_logs=false';
        checkSessionCookieIFrame.id = 'iframeOP';
        checkSessionCookieIFrame.src = checkSessionCookieUrl;
        checkSessionCookieIFrame.style.display = 'none';
        checkSessionCookieIFrame.onload = onIframeLoad;
        document.body.appendChild(checkSessionCookieIFrame);


        if (followCookieCb) {
            window.addEventListener('message', receiveCookieStatus, false);
        }

        function receiveCookieStatus(event) {

            var origin = event.origin || event.originalEvent.origin;
            //if (origin !== 'https://idam-dev.metrosystems.net') {  //Local
            if (origin !== (location.protocol + '//' + location.host)) {
                return;
            }

            followCookieCb(event.data);
            window.removeEventListener('message', receiveCookieStatus, false);

            // remove the iframe once the receive cookie status
            setTimeout(() => {
                cleanUpIFrame('iframeOP');
            }, 300);
        }

        return checkSessionCookieIFrame;
    }

    function checkCookieStatus() {
        var text = 'check_cookie';
        var iframe = document.getElementById("iframeOP");
        //iframe.contentWindow.postMessage(text, 'https://idam-dev.metrosystems.net'); //Local
        iframe.contentWindow.postMessage(text, (location.protocol + '//' + location.host));
        return Promise.resolve();
    }


    function loadCheckSessionIFrame(url, onIframeLoad, followSessionCb) {
        var checkSessionIFrame = document.createElement('iframe');
        var checkSessionIFrameUrl = url + '/authorize/api/oauth2/check_session_iframe';
        checkSessionIFrame.id = 'iframeCheckSessionIframe';
        checkSessionIFrame.src = checkSessionIFrameUrl;
        checkSessionIFrame.style.display = 'none';
        checkSessionIFrame.onload = onIframeLoad;
        document.body.appendChild(checkSessionIFrame);

        if (followSessionCb) {
            window.addEventListener('message', receiveSessionStatus, false);
        }

        function receiveSessionStatus(event) {

            var origin = event.origin || event.originalEvent.origin;
            //if (origin !== 'https://idam-dev.metrosystems.net') { //Local
            if (origin !== (location.protocol + '//' + location.host)) {
                return;
            }

            followSessionCb(event.data);
        }

        return checkSessionIFrame;
    }

    function checkSessionIFrameStatus() {
        var sessionState = localStorage.getItem(oAuthConstants.sessionStateKey); //Local
        //var sessionState = getCookieValue(oAuthConstants.sessionStateKey);

        var text = oAuthConstants.clientId + " " + sessionState;
        var iframe = document.getElementById("iframeCheckSessionIframe");
        //iframe.contentWindow.postMessage(text, 'https://idam-dev.metrosystems.net'); //Local
        iframe.contentWindow.postMessage(text, (location.protocol + '//' + location.host));
        return Promise.resolve();
    }

    function getCookieValue(cookieName) {
        var name = cookieName + "=";
        var cookies = document.cookie.split(';');
        if (!cookies) {
            return null;
        }
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();
            if (cookie.indexOf(name) == 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }
        return null;
    }

});

export default iFrameManager;
